export const environment = {
  production: false,
  apiUrl: 'https://des-api.tramitex.app',
  uniloginUrl: 'https://des-auth.tramitex.app',
  // apiUrl: 'https://localhost:3000',
  // uniloginUrl: 'https://tramitex-des-unilogin.web.app',
};